import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["form", "email", "submitBtn", "successMessage", "errorMessage", "errorText"];

  connect() {
    // Handle form submission via AJAX
    this.formTarget.addEventListener('submit', this.handleSubmit.bind(this));
  }

  async handleSubmit(event) {
    event.preventDefault();

    const email = this.emailTarget.value.trim();

    if (!email) {
      this.showError("Please enter your email address");
      return;
    }

    if (!this.isValidEmail(email)) {
      this.showError("Please enter a valid email address");
      return;
    }

    this.setLoading(true);

    try {
      const formData = new FormData(this.formTarget);
      // Add the magic_link parameter since button click isn't captured in FormData
      formData.append('magic_link', 'Send Magic Link');
      // Add the current path and subdomain info for proper redirect
      formData.append('return_url', window.location.href);

      // Extract subdomain (handle different environments)
      const hostname = window.location.hostname;
      let subdomain = '';

      // Handle localtest.me pattern (subdomain.localtest.me)
      if (hostname.includes('localtest.me')) {
        const parts = hostname.split('.');
        if (parts.length > 2) {
          subdomain = parts[0];
        }
      } else if (hostname.includes('.')) {
        // Handle regular domain pattern (subdomain.domain.com)
        const parts = hostname.split('.');
        if (parts.length > 2) {
          subdomain = parts[0];
        }
      }

      if (subdomain) {
        formData.append('return_subdomain', subdomain);
      }

      const response = await fetch(this.formTarget.action, {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        }
      })

      if (response.ok) {
        this.showSuccess();
      } else {
        const errorData = await response.json().catch(() => ({}));
        this.showError(errorData.message || "We couldn't find an account with that email address");
      }
    } catch (error) {
      console.error('Magic link request failed:', error);
      this.showError("Something went wrong. Please try again.");
    } finally {
      this.setLoading(false);
    }
  }

  showSuccess() {
    this.hideError();
    this.hideSubmit();
    this.successMessageTarget.classList.remove('d-none');
    this.emailTarget.value = '';
  }

  showError(message) {
    this.hideSuccess();
    this.errorTextTarget.textContent = message;
    this.errorMessageTarget.classList.remove('d-none');
  }

  hideSuccess() {
    this.successMessageTarget.classList.add('d-none');
  }

  hideError() {
    this.errorMessageTarget.classList.add('d-none');
  }

  hideSubmit() {
    this.submitBtnTarget.classList.add('d-none');
  }

  setLoading(isLoading) {
    if (isLoading) {
      this.submitBtnTarget.disabled = true;
      this.submitBtnTarget.textContent = this.submitBtnTarget.dataset.loadingText || 'Sending...';
    } else {
      this.submitBtnTarget.disabled = false;
      this.submitBtnTarget.textContent = this.submitBtnTarget.dataset.originalText || 'Send Magic Link';
    }
  }

  isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  // Clear messages when modal is opened
  modalOpened() {
    this.hideSuccess();
    this.hideError();
    this.emailTarget.value = '';
    this.setLoading(false);
  }
}